import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const resultadoInterposicaoRecursoMunicipioRoutes: Routes = [
  {
    path: 'resultado-interposicao-recurso-municipio',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./resultado-interposicao-recurso-municipio.component').then(
            (m) => m.ResultadoInterposicaoRecursoMunicipioComponent,
          ),
        data: {
          title: 'Gerar Resultado Interposição de Recurso Município',
          roles: [Role.RESULTADO_RECURSO_MUNICIPIO_CONSULTAR],
          breadcrumb: [
            { label: 'Gerar Resultado Interposição de Recurso Município', url: '/resultado-interposicao-recurso-municipio' },
          ],
        },
      },
    ],
  },
];
